var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightarrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.06L1.061 0L6.84 5.777C6.93315 5.86957 7.00708 5.97964 7.05753 6.10089C7.10798 6.22214 7.13395 6.35217 7.13395 6.4835C7.13395 6.61483 7.10798 6.74485 7.05753 6.86611C7.00708 6.98736 6.93315 7.09743 6.84 7.19L1.061 12.97L0.000999928 11.91L5.425 6.485L0 1.06Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrowWhite);
export default __webpack_public_path__ + "static/media/rightarrow-white.f1d7b40aa87f0a6e3b65c58f208d523b.svg";
export { ForwardRef as ReactComponent };